import { useEffect, useRef, useState } from 'react';
import { apiFetch } from '../lib/api';

export function StandardDownload({ slug, filename }: { slug: string; filename: string }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const request = useRef<AbortController | null>(null);
  useEffect(() => () => request.current?.abort(), []);
  async function download() {
    if (request.current) return;
    const controller = new AbortController();
    request.current = controller;
    setBusy(true);
    setError('');
    try {
      const content = await apiFetch<string>(`/v1/content/documents/${encodeURIComponent(slug)}/markdown`, { responseType: 'text', signal: controller.signal });
      if (controller.signal.aborted) return;
      const url = URL.createObjectURL(new Blob([content], { type: 'text/markdown;charset=utf-8' }));
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      if (!controller.signal.aborted) setError(err instanceof Error ? err.message : 'Unable to download this standard.');
    } finally {
      if (!controller.signal.aborted) { setBusy(false); request.current = null; }
    }
  }
  return <div id="download" className="standard-download">
    <button className="btn" type="button" disabled={busy} onClick={download}>{busy ? 'Preparing download…' : 'Download Markdown ↓'}</button>
    {error && <p role="alert">{error}</p>}
  </div>;
}
